export default __webpack_public_path__ + "static/media/pwc-logo-white.fd2b3fbd.svg";